/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_Checked_InInputs */

const en_roster_checked_in = /** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checked In`)
};

const es_roster_checked_in = /** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrados`)
};

const fr_roster_checked_in = /** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistré`)
};

const de_roster_checked_in = /** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingecheckt`)
};

const id_roster_checked_in = /** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telah Check-In`)
};

/** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */
const ja_roster_checked_in = en_roster_checked_in;

/** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */
const zh_roster_checked_in = en_roster_checked_in;

/** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */
const ar_roster_checked_in = en_roster_checked_in;

/** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */
const it_roster_checked_in = en_roster_checked_in;

/** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */
const ru_roster_checked_in = en_roster_checked_in;

/** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */
const pt_roster_checked_in = en_roster_checked_in;

/** @type {(inputs: Roster_Checked_InInputs) => LocalizedString} */
const ko_roster_checked_in = en_roster_checked_in;

/**
* | output |
* | --- |
* | "Checked In" |
*
* @param {Roster_Checked_InInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_checked_in = /** @type {((inputs?: Roster_Checked_InInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_Checked_InInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_checked_in(inputs)
	if (locale === "es") return es_roster_checked_in(inputs)
	if (locale === "fr") return fr_roster_checked_in(inputs)
	if (locale === "de") return de_roster_checked_in(inputs)
	if (locale === "ja") return ja_roster_checked_in(inputs)
	if (locale === "zh") return zh_roster_checked_in(inputs)
	if (locale === "ar") return ar_roster_checked_in(inputs)
	if (locale === "id") return id_roster_checked_in(inputs)
	if (locale === "it") return it_roster_checked_in(inputs)
	if (locale === "ru") return ru_roster_checked_in(inputs)
	if (locale === "pt") return pt_roster_checked_in(inputs)
	return ko_roster_checked_in(inputs)
});